
import image, { DIRECTOR_TOP } from "../images"

import {
    metadata,
	FEATURE_STATUS,
	FEATURE_VALUE_STATUS_ACQUISITION,
	FEATURE_VALUE_STATUS_CATALOG,
	FEATURE_VALUE_STATUS_AVAILABLE_SOON,
    FEATURE_BONUS_TYPE
} from "../metadata"


export const isAvailable = (product, countries) => {
	let available = {}
	if (countries) {
		countries.forEach(country => {
			available[country.isoCode] = metadata(product, country.feature_status, { oneOf: [FEATURE_VALUE_STATUS_ACQUISITION, FEATURE_VALUE_STATUS_CATALOG]})
		})
	} else {
		available = metadata(product, FEATURE_STATUS, { oneOf: [FEATURE_VALUE_STATUS_ACQUISITION, FEATURE_VALUE_STATUS_CATALOG]})
	}
	return available
	//return metadata(product, FEATURE_STATUS, { oneOf: [FEATURE_VALUE_STATUS_ACQUISITION, FEATURE_VALUE_STATUS_CATALOG]})
}

export const isAvailableSoon = (product, countries) => {
	let availableSoon = {}
	if (countries) {
		countries.forEach(country => {
			availableSoon[country.isoCode] = metadata(product, country.feature_status, { isEqual: FEATURE_VALUE_STATUS_AVAILABLE_SOON })
		})
	} else {
		availableSoon = metadata(product, FEATURE_STATUS, { isEqual: FEATURE_VALUE_STATUS_AVAILABLE_SOON })
	}
	return availableSoon
	//return metadata(product, FEATURE_STATUS, { isEqual: FEATURE_VALUE_STATUS_AVAILABLE_SOON })
}

export const hideInProduction = (product) => {
	if (process.env.LACINETEK_ENV !== "production") {
		return true
	}

	if (product && (!product.hideInProduction || product.hideInProduction === false)) {
		return true
	}

	return false
}

export const hideInCatalog = (product) => {
	return product && (!product.hideInCatalog || product.hideInCatalog === false)
}


const getDirector = (product) => {
	const { extension: { directors: { items: directors } } } = product
	return directors.find(d => d.roles.includes("Réalisateur") || d.roles.includes("Director"))
}

export const getDirectorName = (product) => {
	const director = getDirector(product)

	return director ? director.director.name : null
}

export const directorImage = (product) => {
	const director = getDirector(product)

	return director ? image(director.director, DIRECTOR_TOP) : ""
}

export const directorGender = (product) => {
	const director = getDirector(product)

	if (!director) {
		return ""
	}

	const { director: { metadata } } = director

	if (!metadata || metadata.length === 0) {
		return ""
	}

	return metadata.find(m => m.name == "genre").value || ""
}

export const getPeople = (product) => {
	const { extension: { directors: { items: directors } } } = product
	return directors
}

export const getDirectors = (product) => {
	const { extension: { directors: { items: directors } } } = product
	return directors.filter(director => director.roles.includes("Réalisateur") || director.roles.includes("Director"))
}

export const BONUS_ARCHIVES = "Archive"
export const BONUS_EXCLUSIFS = "Exclusif"
export const BONUS_TRAILER = "Bande-annonce"
export const BONUS_EXTRACT = "Extrait"

export const getTrailers = product => {
	return product.extension.extracts.items.filter(i => {
		return metadata(i, FEATURE_BONUS_TYPE) == BONUS_TRAILER
	})
}
export const getExtracts = product => {
	return product.extension.extracts.items.filter(i => {
		return metadata(i, FEATURE_BONUS_TYPE) == BONUS_EXTRACT
	})
}
export const getBonuses = (product, type) => {
	if (type) {
		return product.extension.extracts.items.filter(i => {
			return metadata(i, FEATURE_BONUS_TYPE) == type
		})
	} else {
		return product.extension.extracts.items.filter(i => {
			return metadata(i, FEATURE_BONUS_TYPE) && [BONUS_ARCHIVES, BONUS_EXCLUSIFS].includes(metadata(i, FEATURE_BONUS_TYPE))
		})
	}
}
export const getVideos = (product) => {
	return product.extension.extracts.items.filter(i => {
		return metadata(i, FEATURE_BONUS_TYPE) && ![BONUS_ARCHIVES, BONUS_EXCLUSIFS].includes(metadata(i, FEATURE_BONUS_TYPE))
	})
}

export const hasBonus = (product, type) => {
	return getBonuses(product, type).length > 0
}
export const hasTrailer = product => {
	return getTrailers(product).length > 0
}
export const hasExtract = product => {
	return getExtracts(product).length > 0
}
export const hasFilm = product => {
	return getVideos(product).length > 0
}

